angular.module('rjmNg.directives').directive "sqlResult", [
  "$rootScope"
  (
    $rootScope
  ) ->
    restrict: "E"
    templateUrl: "directive.sqlResult.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "$scope"
      "$element"
      "reportQueryType"
      "figureService"
      "$timeout"
      (
        $scope
        $element
        reportQueryType
        figureService
        $timeout
      ) ->
        view = @
        TABLE = 0
        CHART = 1

        minSize = 0
        medSize = 1
        maxSize = 2

        $sqlReportBuilder = $(".rj-sql-report-builder-view")

        view.isLoading = false

        view.figure =
          data: null
          query: {}

        view.chartType = null

        view.tabState = TABLE
        view.resultsSize = minSize

        view.showChart = () ->
          if view.tabState isnt CHART
            view.tabState = CHART
            if view.resultsSize == minSize
              view.medResultsSize()

        view.showTable = () ->
          if view.tabState isnt TABLE
            view.tabState = TABLE
            if view.resultsSize == minSize
              view.medResultsSize()
            $timeout ->
              view.resizeTable()

        view.renderServerMessage = (message) ->
          view.message = message

        view.renderFigure = (data, presentation) ->
          view.message = null

          unless data?
            data =
              body: []
              header: []

          view.figure =
            data: data
            reportQueryType: reportQueryType.SQL
            presentation: presentation
            created: moment().format()

          view.chartType = figureService.getChartTypeFromFigure(view.figure, true)

        view.minResultsSize = () ->
          # DEFAULT SQL Report Builder STATE
          if $sqlReportBuilder.hasClass("max-results-size")
            $sqlReportBuilder.removeClass("max-results-size")
          $sqlReportBuilder.addClass("min-results-size")

          view.resultsSize = minSize

        view.medResultsSize = () ->
          if $sqlReportBuilder.hasClass("max-results-size")
            $sqlReportBuilder.removeClass("max-results-size")
          if $sqlReportBuilder.hasClass("min-results-size")
            $sqlReportBuilder.removeClass("min-results-size")

          view.resultsSize = medSize

        view.maxResultsSize = () ->
          if $sqlReportBuilder.hasClass("min-results-size")
            $sqlReportBuilder.removeClass("min-results-size")
          $sqlReportBuilder.addClass("max-results-size")

          view.resultsSize = maxSize

        view.showChartTypes = () ->
          return (view.resultsSize != 0 and view.tabState == 1)

        view.resizeTable = () ->
          if view.tabState is TABLE
            figureContent = $element.find(".figure-content")
            if figureContent[0]?
              $scope.$broadcast "resizeDataTable", figureContent.width(), figureContent.height()

        view.renderFigure()
        return view
    ]
    link: (scope, elem, attrs, view) ->

      elem.bind("transitionend", (event) ->
        if event?.originalEvent?.propertyName is "height"
          $rootScope.$broadcast 'redrawSQLResult'
          view.resizeTable()
      )

      scope.$on 'runSqlQuery', () ->
        view.medResultsSize()

      scope.$on "dataTableUpdated", () ->
        view.resizeTable()

      scope.$on 'updateResult', (event, result) ->
        if result.data.data.error?
          friendlyError = result.data.data.error.replace(/.(ERROR)/g, "<br>\nERROR")
          view.renderServerMessage(friendlyError)
        else
          data = result.data.data
          presentation = result.data.presentation

          consolidated = [data.header].concat(data.body)
          view.renderFigure(data, presentation)
]
